const PhoneCell = ({ data }: any) => {
  return <div>{data.phone}</div>
}

export { PhoneCell }
